module.exports = __webpack_public_path__ + "static/media/VIP_Message_Background@3x.54e9fb7e.png";